import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import TemplatedText from '../../../components/templated-text';
import type { CustomQuestionsFormData } from '../../../types';
import { previewLabel } from '../../../utils/preview-label';
type CheckboxPreviewProps = {
  questionIndex: number;
};
const CheckboxPreview = t0 => {
  const $ = _c(14);
  const {
    questionIndex
  } = t0;
  const {
    control
  } = useFormContext();
  const t1 = `questions.${questionIndex}.label`;
  const t2 = `questions.${questionIndex}.required`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [t1, t2];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== control || $[4] !== t3) {
    t4 = {
      control,
      name: t3
    };
    $[3] = control;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [label, required] = useWatch(t4);
  let t5;
  if ($[6] !== label || $[7] !== required) {
    t5 = previewLabel(label, required, _temp);
    $[6] = label;
    $[7] = required;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const labelWithOptional = t5;
  const t6 = `questions.${questionIndex}.preview`;
  let t7;
  if ($[9] !== labelWithOptional) {
    t7 = labelWithOptional && <TemplatedText value={labelWithOptional} />;
    $[9] = labelWithOptional;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <Form.Checkbox name={t6} label={t7} />;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default CheckboxPreview;
function _temp(trimmed) {
  return `${trimmed} (Optional)`;
}